/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Taxonomy_Detail_Related_CategoriesInputs */

const en_directory_taxonomy_detail_related_categories = /** @type {(inputs: Directory_Taxonomy_Detail_Related_CategoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Related sub-categories`)
};

const zh_directory_taxonomy_detail_related_categories = /** @type {(inputs: Directory_Taxonomy_Detail_Related_CategoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`相关子分类`)
};

/**
* | output |
* | --- |
* | "Related sub-categories" |
*
* @param {Directory_Taxonomy_Detail_Related_CategoriesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_taxonomy_detail_related_categories = /** @type {((inputs?: Directory_Taxonomy_Detail_Related_CategoriesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Taxonomy_Detail_Related_CategoriesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_taxonomy_detail_related_categories(inputs)
	return zh_directory_taxonomy_detail_related_categories(inputs)
});
export { directory_taxonomy_detail_related_categories as "directory.taxonomy_detail.related_categories" }